import { IRequest } from '@r1-frontend/shared/types/IRequest';

const DEFAULT_CATEGORY = 4;

export interface IPayRequest {
    bonusValue: number,
    categoryId?: number,
}

export interface IPayResponse {
    loyaltyNumber: string,
    bonuses: number,
}

/*
* Оплата бонусами программы лояльности
* https://master.api-loyalty.sandbox.d2c.r-one.io/docs/v1#/Loyalty%20Program/a4ebbb3d7a3998eae9f0b25f495e354f
* */
export const pay = (providerId: number, { bonusValue, categoryId = DEFAULT_CATEGORY }: IPayRequest): IRequest => ({
    uri: '/v1/program/pay',
    method: 'POST',
    withAuth: true,
    headers: { providerId: `${providerId}` },
    body: JSON.stringify({
        scores: bonusValue,
        categoryId,
    }),
});
